import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_3 = { class: "flex card-toolbar w-full" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "p-input-icon-left w-10/12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "card-toolbar w-full" }
const _hoisted_8 = { class: "flex flex-row items-center justify-between" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex flex-col ml-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "card-body pt-0" }
const _hoisted_15 = { class: "ml-96 mt-10" }

import {computed, onBeforeMount, onMounted, ref, watch} from "vue";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import router from "@/router";
import ApiService from "@/_services/api.service";
import { useRoute } from 'vue-router';
import { categoryService } from "@/_services/category/category";
import { SocialEventBrands } from "@/models/product/brands/SocialEventBrands";
import Dropdown from "primevue/dropdown";

const tableLocalStorageKey = "tableSelectedBrandsToMap";
const selectedBrandToMapStorageKey = "selectedBrandsToMap";
const selectAllBtnStatusStorageKey = "selectAllBrandsForMappingBtnStatus";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'MappingCategoryUrssafBrand',
  setup(__props) {

const isSelectAllBtnChecked = ref<boolean>(false);
const refItemsPerPage = ref<number>(0);
const isLoading = ref<boolean>(true);
const brands = Array<SocialEventBrands>();
const tableData = ref<Array<SocialEventBrands>>(brands);
const allBrands = ref<Array<SocialEventBrands>>([]);
const originalBrands = ref<Array<SocialEventBrands>>([]);
const totalSelectedBrands = ref<number>(0);
const brandsOfCurrentPage = ref(Array<SocialEventBrands>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100, 250];
const isFormSubmitted = ref(false);
const selectedBrands = ref<SocialEventBrands[]>([]);
const category_model = ref<{uuid: string}>({uuid: ''});
const route = useRoute();
const selectedSupplier = ref<{name: string} | null>(null);
const uniqueSuppliers = ref<{name: string}[]>([]);

const preselectCategory = async () => {
    const categoryUuid = route.params.uuid as string;
    if (categoryUuid) {
        category_model.value = {
            uuid: categoryUuid
        };
    }
};

onBeforeMount(() => {
    initLocalStorageData();
});

onMounted(async () => {
    await preselectCategory();
    await populateDataTableWithLocalStorageFilters();
});

watch(isSelectAllBtnChecked, () => {
    setIsSelectedAllBtnStatusLocalStorage(isSelectAllBtnChecked.value);
});

const isInFilteredView = computed(() => {
    return totalSelectedBrands.value > 0;
});

const initLocalStorageData = () => {
    if (localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.removeItem(selectAllBtnStatusStorageKey);
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (localStorage.getItem(selectedBrandToMapStorageKey)) {
        localStorage.removeItem(selectedBrandToMapStorageKey);
    }

    if (!localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.setItem(selectAllBtnStatusStorageKey, 'false');
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (!localStorage.getItem(selectedBrandToMapStorageKey)) {
        localStorage.setItem(selectedBrandToMapStorageKey, '[]');
    }
}

function createBrandIdentifier(brand: SocialEventBrands): string {
    return `${brand.brand}__${brand.supplier}`;
}

async function submitHandler() {
    const selectedBrandIds = getSelectedBrandsToMapFromStorage();
    
    const selectedBrandNames = selectedBrandIds.map(brandId => {
        const brand = findBrandById(brandId);
        return brand ? brand.brand : null;
    }).filter(Boolean) as string[];

    const payload = {
        socialEvent: "/api/social_events/" + category_model.value.uuid,
        brands: selectedBrandNames,
    };

    try {
        const response = await ApiService.post('social_event_brands', payload);
        
        swal.success('Succès', 'La(les) marque(s) a/ont été associée(s) avec succès à la catégorie URSSAF.');
        
        setTimeout(() => {
            const routeLocation = router.resolve({ 
                name: 'editMappingCategoryUrssafBrand', 
                params: { uuid: route.params.uuid } 
            });
            window.location.href = routeLocation.href;
        }, 1500);
    } catch (error: any) {
        
        if (error.response) {
            
            if (error.response.data && error.response.data.hasError) {
                const errors = error.response.data.errors;
                
                if (errors && errors.length > 0) {
                    const errorMessage = errors[0].message;
                    swal.error(errorMessage);
                } else {
                    swal.error('Une erreur est survenue lors de la tentative d\'association des marques.');
                }
            } else if (error.response.data && error.response.data.detail) {
                // Format d'erreur Symfony/API Platform
                swal.error(error.response.data.detail);
            } else if (error.response.data && error.response.data.message) {
                // Autre format possible
                swal.error(error.response.data.message);
            } else {
                swal.error(`Erreur du serveur: ${error.response.status}`);
            }
        } else if (error.request) {
            swal.error('Aucune réponse reçue du serveur. Veuillez vérifier votre connexion réseau.');
        } else {
            swal.error(`Erreur: ${error.message}`);
        }
    }
}

const setIsSelectedAllBtnStatusLocalStorage = (status: boolean) =>{
    isSelectAllBtnChecked.value = status;
    const isSelectedAllBtnInStorageData = localStorage.getItem(selectAllBtnStatusStorageKey);
    if (!isSelectedAllBtnInStorageData) {
        localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
    } else {
        const currentStatus = JSON.parse(isSelectedAllBtnInStorageData);
        if (currentStatus !== status) {
            localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
        }
    }
}

function onSearchInputDt() {
    let search = criteria.value.trim();
    if (0 === search.length || 3 <= search.length) {
        page.value = 1;
        applyFilters();
    }
}

async function populateDatatable() {
    isLoading.value = true;
    
    try {
        if (category_model.value.uuid) {
            const result = await categoryService.fetchSocialEventAllBrands(category_model.value.uuid);
            
            isLoading.value = result.isLoading.value;
            
            if (result.hasError.value) {
                swal.error(result.errorMessage.value || 'Erreur lors de la récupération des marques');
                originalBrands.value = [];
                allBrands.value = [];
                tableData.value = [];
                totalRecords.value = 0;
            } else {
                result.brands.value.forEach(brand => {
                    brand.id = `${brand.brand}__${brand.supplier}`;
                });
                originalBrands.value = result.brands.value;
                
                uniqueSuppliers.value = extractUniqueSuppliers(result.brands.value);
                
                applyFilters();
                
                const preSelectedBrands = result.brands.value.filter(brand => brand.isSelected);
                if (preSelectedBrands.length > 0) {
                    selectedBrands.value = preSelectedBrands;
                    totalSelectedBrands.value = preSelectedBrands.length;
                    
                    const preSelectedBrandIds = preSelectedBrands.map(brand => createBrandIdentifier(brand));
                    addSelectedBrandInBrandsToMapInStorage(preSelectedBrandIds);
                }
                
                isSelectAllBtnChecked.value = (tableData.value.length > 0) && 
                                                (tableData.value.every(brand => 
                                                selectedBrands.value.some(selected => 
                                                    createBrandIdentifier(selected) === createBrandIdentifier(brand))));
            }
        }
    } catch (error) {
        isLoading.value = false;
        swal.error('Une erreur est survenue lors de la récupération des marques.');
    }

    return [isLoading.value, totalRecords.value, tableData.value];
}

function applyPagination() {
    const startIndex = (page.value - 1) * rows.value;
    const endIndex = Math.min(startIndex + rows.value, allBrands.value.length);
    
    tableData.value = allBrands.value.slice(startIndex, endIndex);
    brandsOfCurrentPage.value = tableData.value;
}

async function populateDataTableWithLocalStorageFilters(itemsPerPage?: number, page?: number) {
    let localStorageRowPerPage = getLocalStorageRowsPerPage();
    let localStorageFisrtPageState = getLocalStorageFisrtPageState();
    let currentPage = page;
    if (!currentPage) {
        currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
    }
    let currentItemsPerPage = itemsPerPage;
    if (!currentItemsPerPage) {
        currentItemsPerPage = localStorageRowPerPage;
    }

    await populateDatatable();
}

const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    setLocalStorageRowsPerPage(rows.value);

    applyPagination();
    
    const selectedBrandsIds = getSelectedBrandsToMapFromStorage();
    isSelectAllBtnChecked.value = brandsOfCurrentPage.value.length > 0 && 
        brandsOfCurrentPage.value.every(brand => 
            selectedBrandsIds.includes(createBrandIdentifier(brand))
        );
    
    hideSpinner();
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

const onRowSelectAll = async (event): Promise<void> => {
    if (true === event.checked) {
        isSelectAllBtnChecked.value = true;
        selectedBrands.value = brandsOfCurrentPage.value;
        const brandsOfCurrentPageToSelect = brandsOfCurrentPage.value
            .filter((item) => !getSelectedBrandsToMapFromStorage().includes(createBrandIdentifier(item)))
            .map(item => createBrandIdentifier(item));
        if (brandsOfCurrentPageToSelect.length > 0) {
            addSelectedBrandInBrandsToMapInStorage(brandsOfCurrentPageToSelect);
            const currentBrandsToMapInStorage = getSelectedBrandsToMapFromStorage();
            let newBrandsToMapInStorage = currentBrandsToMapInStorage;
            brandsOfCurrentPageToSelect.forEach((brandId: string) => {
                if (!currentBrandsToMapInStorage.includes(brandId)) {
                    newBrandsToMapInStorage.push(brandId);
                }
            });
            totalSelectedBrands.value = newBrandsToMapInStorage.length;
        }
    } else {
        isSelectAllBtnChecked.value = false;
        const unSelectedBrandsOfCurrentPageToRemoveInStorage = brandsOfCurrentPage.value.map(item => createBrandIdentifier(item));
        removeUnSelectedBrandFromBrandsToMapInStorage(unSelectedBrandsOfCurrentPageToRemoveInStorage);

        const brandsToMapInStorage = getSelectedBrandsToMapFromStorage();
        let newBrandsToMapInStorage = brandsToMapInStorage.filter(brandId => !unSelectedBrandsOfCurrentPageToRemoveInStorage.includes(brandId));
        totalSelectedBrands.value = newBrandsToMapInStorage.length;
        selectedBrands.value = selectedBrands.value.filter((item) =>
            !brandsOfCurrentPage.value.map((brand) => createBrandIdentifier(brand)).includes(createBrandIdentifier(item))
        );

        hideSpinner();
    }
};

const onRowSelect = async (event: any): Promise<void> => {
    const selectedBrand = event.data;
    const selectedBrandId = createBrandIdentifier(selectedBrand);
    totalSelectedBrands.value++;
    addSelectedBrandInBrandsToMapInStorage([selectedBrandId]);
    const totalSelectedBrandsOnCurrentPage = getTotalUnSelectedBrandsOnCurrentPage();
    isSelectAllBtnChecked.value = (refItemsPerPage.value - totalSelectedBrandsOnCurrentPage) === refItemsPerPage.value;
}

const onRowUnselect = async (event: any): Promise<void> => {
    const unSelectedBrand = event.data;
    const unSelectedBrandId = createBrandIdentifier(unSelectedBrand);
    removeUnSelectedBrandFromBrandsToMapInStorage([unSelectedBrandId]);
    const brandsToMapInStorage = getSelectedBrandsToMapFromStorage();
    let newBrandsToMapInStorage = brandsToMapInStorage.filter(brandId => brandId !== unSelectedBrandId);
    totalSelectedBrands.value = newBrandsToMapInStorage.length;
    isSelectAllBtnChecked.value = false;

    selectedBrands.value = selectedBrands.value.filter(
        (item) => createBrandIdentifier(item) !== unSelectedBrandId
    );
}

const getSelectedBrandsToMapFromStorage = (): string[] => {
    const selectedBrandsToMap = localStorage.getItem(selectedBrandToMapStorageKey);
    return selectedBrandsToMap ? JSON.parse(selectedBrandsToMap) : [];
}

const addSelectedBrandInBrandsToMapInStorage = (brandIds: string[]) => {
    if (brandIds.length === 0) {
        totalSelectedBrands.value = 0;
        localStorage.setItem(selectedBrandToMapStorageKey, JSON.stringify([]));
        return;
    }

    let brandsToMapInStorage = getSelectedBrandsToMapFromStorage();
    brandIds.forEach(brandId => {
        if (!brandsToMapInStorage.includes(brandId)) {
            brandsToMapInStorage.push(brandId);
        }
    });
    localStorage.setItem(selectedBrandToMapStorageKey, JSON.stringify(brandsToMapInStorage));
}

const removeUnSelectedBrandFromBrandsToMapInStorage = (brandIds: string[]) => {
    let brandsToMapInStorage = getSelectedBrandsToMapFromStorage();
    let newBrandsToMapInStorage = brandsToMapInStorage.filter(brandId => !brandIds.includes(brandId));
    localStorage.setItem(selectedBrandToMapStorageKey, JSON.stringify(newBrandsToMapInStorage));
}

const getTotalUnSelectedBrandsOnCurrentPage = (): number => {
    return brandsOfCurrentPage.value
        .filter((item) => !getSelectedBrandsToMapFromStorage().includes(createBrandIdentifier(item))).length;
};

function getLocalStorageData() {
    let storageData = localStorage.getItem(tableLocalStorageKey);
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(tableLocalStorageKey);
    if (storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(tableLocalStorageKey, JSON.stringify(localStorageObject));
    }
}

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

function findBrandById(brandId: string): SocialEventBrands | undefined {
    const [brandName, supplierName] = brandId.split('__');
    return allBrands.value.find(brand => brand.brand === brandName && brand.supplier === supplierName);
}

function extractUniqueSuppliers(brands: SocialEventBrands[]): {name: string}[] {
    const supplierSet = new Set<string>();
    
    brands.forEach(brand => {
        if (brand.supplier) {
            supplierSet.add(brand.supplier);
        }
    });
    
    return Array.from(supplierSet).map(supplier => ({ name: supplier }));
}

function onSupplierFilterChange() {
    page.value = 1;
    applyFilters();
}

function applyFilters() {
    showSpinner();
    
    let filteredResults = [...originalBrands.value];
    
    if (criteria.value.trim() !== '') {
        filteredResults = filteredResults.filter(brand => {
            return brand.brand.toLowerCase().includes(criteria.value.toLowerCase()) || 
                    brand.supplier.toLowerCase().includes(criteria.value.toLowerCase());
        });
    }
    
    if (selectedSupplier.value) {
        filteredResults = filteredResults.filter(brand => 
            brand.supplier === selectedSupplier.value?.name
        );
    }
    
    allBrands.value = filteredResults;
    totalRecords.value = filteredResults.length;
    
    applyPagination();
    
    hideSpinner();
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    type: "form",
    "form-class": isFormSubmitted.value ? 'hide' : 'show',
    onSubmit: submitHandler,
    actions: false
  }, {
    default: _withCtx(({ state: { valid } }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(DataTable), {
          lazy: "",
          dataKey: "id",
          stateStorage: "local",
          ref: "dt",
          "state-key": tableLocalStorageKey,
          value: tableData.value,
          paginator: true,
          rows: rows.value,
          rowHover: true,
          sortMode: "multiple",
          removableSort: "",
          selection: selectedBrands.value,
          "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((selectedBrands).value = $event)),
          metaKeySelection: false,
          loading: isLoading.value,
          totalRecords: totalRecords.value,
          currentPage: currentPage.value,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          rowsPerPageOptions: rowsPerPageOptions,
          currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
          selectAll: isSelectAllBtnChecked.value,
          onSelectAllChange: _cache[4] || (_cache[4] = ($event: any) => (onRowSelectAll($event))),
          onRowSelect: _cache[5] || (_cache[5] = ($event: any) => (onRowSelect($event))),
          onRowUnselect: _cache[6] || (_cache[6] = ($event: any) => (onRowUnselect($event))),
          onPage: _cache[7] || (_cache[7] = ($event: any) => (onPaginate($event)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_unref(InputText), {
                      type: "text",
                      class: "w-9/12",
                      modelValue: criteria.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (onSearchInputDt()), ["prevent"]), ["enter"])),
                      placeholder: "Rechercher par marque"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, "Nombre total de marques : " + _toDisplayString(totalRecords.value), 1),
                    _createElementVNode("p", null, "Nombre de marque(s) sélectionnée(s) : " + _toDisplayString(totalSelectedBrands.value) + " marque(s)", 1),
                    (isInFilteredView.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Vous êtes en vue filtrée"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(Dropdown), {
                      modelValue: selectedSupplier.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedSupplier).value = $event)),
                      options: uniqueSuppliers.value,
                      optionLabel: "name",
                      placeholder: "Sélectionner un fournisseur",
                      filter: "",
                      showClear: true,
                      class: "w-64",
                      onChange: onSupplierFilterChange
                    }, {
                      value: _withCtx((slotProps) => [
                        (slotProps.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(slotProps.value.name), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, "Sélectionner un fournisseur"))
                      ]),
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ])
                ])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode("Aucun résultat trouvé.")
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(Column), { selectionMode: "multiple" }),
              _createVNode(_unref(Column), {
                field: "brand",
                header: "Marque"
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("span", null, _toDisplayString(slotProps.data.brand), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "supplier",
                header: "Fournisseur"
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("span", null, _toDisplayString(slotProps.data.supplier), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["value", "rows", "selection", "loading", "totalRecords", "currentPage", "selectAll"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_FormKit, {
          type: "submit",
          label: "Enregistrer",
          disabled: !valid
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["form-class"]))
}
}

})